import { fetchWithToken } from '../fetcher'

const CREATE_EMPTY_CART = `
mutation createEmptyCart {
    createEmptyCart
  }
`
const MERGE_CART = `
mutation mergeCartGuestToCartCustomer($source_cart_id: String!, $destination_cart_id: String) {
  mergeCarts(
    source_cart_id: $source_cart_id
    destination_cart_id: $destination_cart_id
  ) {
    email
    id
    total_quantity
  }
}`

const ADD_TO_CART = `
mutation addProductToCart($cartId: String!, $cartItems: [CartItemInput!]!) {
  addProductsToCart(cartId: $cartId, cartItems: $cartItems) {
    cart {
      email
      id
      is_virtual
      total_quantity
    }
    user_errors {
      code
      message
    }
  }
} `

const REMOVE_CART_ITEM = `
mutation RemoveItemForMiniCart(
  $removeItemFromCartInput: RemoveItemFromCartInput
) {
  removeItemFromCart(input: $removeItemFromCartInput) {
    cart {
      id
      items {
        uid
        errors {
          code
          message
        }
      }
    }
  }
}
`

const UPDATE_CART = `
mutation updateCartItem($input: UpdateCartItemsInput) {
  updateCartItems(input: $input) {
    cart {
      email
      id
      is_virtual
    }
  }
}
`



const createEmptyCart = async () => {
  try {
    const res = await fetchWithToken(
      {
        query: CREATE_EMPTY_CART,
      },
      {
        next: { tags: ['cart-guest'] },
      }
    )
    const id = res?.payload?.data?.createEmptyCart
    return id
  } catch (err) {
    console.log('Error when creating empty cart: ', err)
    return null
  }
}

const mergeCartGuestToUser = async (source_cart_id: string) => {
  try {
    let idCartCustomer = await fetchWithToken(
      {
        query: CREATE_EMPTY_CART,
      },
      {
        next: { tags: ['cart-customer'] },
      }
    ).then((res) => res?.payload?.data?.createEmptyCart)
    const res = await fetchWithToken({
      query: MERGE_CART,
      variables: {
        source_cart_id: source_cart_id, // id cart guest
        destination_cart_id: idCartCustomer, //id cart customer
      },
    })
    const id = res?.payload?.data?.mergeCarts?.id
    if (!id) return { data: null, status: 'error', message: res?.payload?.errors?.[0]?.message }
    return id
  } catch (err) {
    console.log("Error when merging guest's cart to user's cart: ", err)
    return null
  }
}

const addToCartAction = async (items: ICartItem[], cartId: string) => {
  try {
    const res = await fetchWithToken({
      query: ADD_TO_CART,
      variables: {
        cartId: cartId,
        cartItems: items,
      },
    })
    const id = res?.payload?.data?.addProductsToCart
    return id
  } catch (err) {
    console.log('Error when adding items to cart: ', err)
    return null
  }
}

const removeCartItem = async (cartId: string, cartItemUID: string) => {
  try {
    const res = await fetchWithToken({
      query: REMOVE_CART_ITEM,
      variables: {
        removeItemFromCartInput: {
          cart_id: cartId,
          cart_item_uid: cartItemUID,
        },
      },
    }).then((res) => res?.payload)
    const data = res?.data?.removeItemFromCart
    if (!data) return { data: null, message: res?.errors?.[0]?.message, status: 'error' }
    return data
  } catch (err) {
    console.log('Error when adding items to cart: ', err)
    return null
  }
}

const updateCart = async (cartId: string, dataItem: Record<string, string>) => {
  try {
    const res = await fetchWithToken({
      query: UPDATE_CART,
      variables: {
        input: {
          cart_id: cartId,
          cart_items: [
            {
              cart_item_uid: dataItem?.cart_item_uid,
              quantity: dataItem?.quantity,
            },
          ],
        },
      },
    }).then((res) => res?.payload)
    const data = res?.data?.updateCartItems
    if (!data) return { data: null, message: res?.errors?.[0]?.message, status: 'error' }
    return data
  } catch (err) {
    console.log('Error when adding items to cart: ', err)
    return null
  }
}
type TIemUpdate = {
  cart_item_uid: string
  quantity: number
  available_to_checkout: boolean
}
export const updateCartAll = async (cartId: string, dataItem: TIemUpdate[]) => {
  try {
    const res = await fetchWithToken({
      query: UPDATE_CART,
      variables: {
        input: {
          cart_id: cartId,
          cart_items: dataItem,
        },
      },
    }).then((res) => res?.payload)
    const data = res?.data?.updateCartItems
    if (!data) return { data: null, message: res?.errors?.[0]?.message, status: 'error' }
    return data
  } catch (err) {
    console.log('Error when adding items to cart: ', err)
    return null
  }
}

export {
  addToCartAction,
  CREATE_EMPTY_CART,
  createEmptyCart,
  mergeCartGuestToUser,
  removeCartItem,
  updateCart,
}
